class CollectionBannerTabs extends HTMLElement {
  connectedCallback() {
    this.tabButtons = Array.from(this.querySelectorAll('[role="tab"]'));
    this.tabPanels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

    this.tabButtons.forEach((button) => {
      button.addEventListener('click', this.onTabClick.bind(this));
      button.addEventListener('keydown', this.onKeyDown.bind(this));
    });
  }

  onTabClick(event) {
    this.activateTab(event.currentTarget);
  }

  onKeyDown(event) {
    const currentIndex = this.tabButtons.indexOf(event.currentTarget);
    if (currentIndex === -1) return;

    let nextIndex = null;

    switch (event.key) {
      case 'ArrowRight':
        nextIndex = (currentIndex + 1) % this.tabButtons.length;
        break;
      case 'ArrowLeft':
        nextIndex = (currentIndex - 1 + this.tabButtons.length) % this.tabButtons.length;
        break;
      case 'Home':
        nextIndex = 0;
        break;
      case 'End':
        nextIndex = this.tabButtons.length - 1;
        break;
      default:
        return;
    }

    event.preventDefault();
    this.activateTab(this.tabButtons[nextIndex]);
    this.tabButtons[nextIndex].focus();
  }

  activateTab(button) {
    const panelId = button.getAttribute('aria-controls');
    const panel = this.querySelector(`#${panelId}`);
    if (!panel) return;

    this.tabButtons.forEach((tab) => {
      const isSelected = tab === button;
      tab.setAttribute('aria-selected', isSelected ? 'true' : 'false');
      tab.classList.toggle('is-active', isSelected);
      tab.tabIndex = isSelected ? 0 : -1;
    });

    this.tabPanels.forEach((tabPanel) => {
      const isActive = tabPanel === panel;
      tabPanel.classList.toggle('is-active', isActive);
      tabPanel.hidden = !isActive;
    });
  }
}

if (!customElements.get('collection-banner-tabs')) {
  customElements.define('collection-banner-tabs', CollectionBannerTabs);
}

document.addEventListener('click', (event) => {
  const copyButton = event.target.closest('[data-discount-code]');
  if (!copyButton) return;

  const code = copyButton.dataset.discountCode;
  if (!code) return;

  navigator.clipboard.writeText(code).then(() => {
    const originalLabel = copyButton.textContent;
    copyButton.textContent = 'Copied!';
    window.setTimeout(() => {
      copyButton.textContent = originalLabel;
    }, 2000);
  });
});
